import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";


export class action_AP_FireRefreshDataEvent extends Component implements IActionBase {
    actionCode = "action_AP_FireRefreshDataEvent";
    actionName = "Fire Refresh Data Event";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {
        sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "callDispatch", dispatchType: "REFRESH_DATA_FOR_UI_COMPONENTS"})
        //
        // dispatch({ type: 'SET_DATA',
        //     projectID: props.projectID,
        //     data: prmResponse?.reponseObj?.Data,
        //     responseObj: prmResponse?.reponseObj });

    }

}